var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"padding"},[_c('view-owner-info',{ref:"viewOwnerInfo",attrs:{"show-call-back-button":true},on:{"notify":_vm.handleNotify,"callBackListOwner":_vm.goBack}}),_c('show-owner-room',{attrs:{"deleteOwnerRoomFlag":_vm.deleteOwnerRoomFlag,"ownerId":_vm.ownerId,"ownerName":_vm.ownerName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }